<template>
  <!--<transition name="alertNum">-->
    <div class="alert-num" v-if="boxshow">
      <div class="alert-num-body bg-white amint">
        <div class="top padding-5">
          <img src="../../assets/image/logo-b.svg" width="100" style="vertical-align: bottom">
          <span class="font-0-8">请确认菜品数量</span>
        </div>
        <div style=" padding: 0 10px;margin-top: 55px;" class="magin-t-6">
          <bg-yun>
            <div class="padding-16 text-center">{{order.name}}</div>
          </bg-yun>
        </div>
        <div class="magin-t-6" style=" padding: 0 10px;">
          <bg-yun>
            <div class=" flex-layout " style="padding: 10px 5px">
              <div class="flex-2 color-yellow font-0-8 text-nowrap">{{order.price}}元<span v-if="order.standard">/{{order.standard}}</span></div>
              <div class="flex-2 color-blue font-0-8 text-nowrap" style="padding-left: 5px;">
                <img v-if="order.memberprice<order.price" src="../../assets/image/vipIco.svg" width="15" style="vertical-align: middle;margin-top: -3px;">
                <span v-if="order.memberprice<order.price">￥{{order.memberprice}}元<span v-if="order.standard">/{{order.standard}}</span></span>
              </div>
              <div class="flex-3 text-right" style="line-height: 5px;flex: 4.5">
               <span class="suit-num" @click.stop="clickSub()">
                <img src="../../assets/image/subIcon.svg" width="30" style="vertical-align: middle;pointer-events: none;">
              </span>
                <span class="suit-num" >{{order.num}}
                  <span v-if="order.minOrderNum>1&&order.num === order.minOrderNum" style="font-size: 10px;color: orangered">起点</span>
                </span>
                <span class="suit-num" @click.stop="clickAdd()">
                <img src="../../assets/image/addIcon.svg" width="30" style="vertical-align: middle;pointer-events: none;">
              </span>
              </div>
            </div>
          </bg-yun>
        </div>
        <div class="bottom flex-layout text-center">
          <div @click.stop="btnCancel()" class="flex-1 bg-yellow padding-10 color-gray-yellow">取消</div>
          <div @click.stop="btnOk()" class="flex-1 bg-gray-yellow padding-10 color-white">确定</div>
        </div>
      </div>
    </div>
  <!--</transition>-->
</template>
<script >
  import ServiceUtils from '../../service/ServiceUtils';
  import bgyun from "../bg-yun/bgyun";
  export default {
    name: 'alertnum',
    data () {
      return {
        boxshow:false,
        order:{},
        type:{},
        _fun:{}
      };
    },
    methods:{
      togglebox:function(tpe,order,callback){
        order.num =  Math.max(order.minOrderNum || 1,1);
        this.order = order ;
        this.type = tpe ;
        this.boxshow = !this.boxshow;
        if(callback){
          this._fun = callback;
        }

//        this.suit = suit;
      },
      btnCancel(){
        this.boxshow = !this.boxshow;
      },
      btnOk(){
        let food = {
            code:this.type.code,
            name:this.type.name,
            ename:this.type.sndname||"",
            isGroup:0,
            menuItem:{
              code: this.order.code,
              name: this.order.name,
              sndname: this.order.sndname,
              price: this.order.price,
              memberprice: this.order.memberprice||"0",
              standard: this.order.standard,
              num: this.order.num,
              menuItem: [],
              memo: ""
            }
          };
        this.boxshow = !this.boxshow;
        this._fun(food);
      },
      clickSub:function(){
        this.order.num--;
        // this.order.num =  Math.max(this.order.num,1);
        this.order.num =  Math.max(this.order.num,this.order.minOrderNum || 1);
        this.$forceUpdate();
      },
      clickAdd:function(){
        this.order.num ++ ;
        this.$forceUpdate();
      },

    },
    components:{
      'bg-yun':bgyun
    },

    created(){

    }
  }
</script>
<style>

  .amint{animation: bounce-in .2s;}
  @keyframes bounce-in {
    0% {transform: scale(0);}
    100% {transform: scale(1);}
  }
  .text-nowrap{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}

  .color-yellow{color:#FF6D00}
  .top{position: absolute;top:0;left: 0;right: 0;height: 55px;z-index: 15;}
  .padding-5{padding: 5px;}
  .alert-num{position: fixed;top:0;bottom: 0;left: 0;right: 0;background-color: rgba(0, 0, 0, 0.7);z-index: 15;}
  .alert-num-body{position: absolute;top:20%;left: 5%;right: 5%;border-radius: 5px;overflow: hidden;}
  .bottom{margin-top: 10px;line-height: 40px;}
  .font-0-8{font-size: 0.8em;}
  .magin-t-6{margin-top: 6px;}
  .flex-layout{ display: flex;  align-items: center;}
  .text-center{text-align: center}
  .padding-16{padding: 16px;}
  .flex-2{flex:2;overflow:hidden;width: 0}
  .padding-10{padding: 10px;}
  .flex-3{flex:3;overflow:hidden;width: 0}
  .text-right{text-align: right}
  .suit-num{  display: inline-block;  border-radius: 3px;   text-align: center; min-width: 30px }

  .bg-white{background:#ffffff}
  .color-white{color:#ffffff}
  .flex-1{flex:1;overflow:hidden;width: 0}
  .color-blue{color:#00ABF8}
  .color-gray-yellow{color:#CEB66B}
  .bg-gray-yellow{background:#CEB66B}
  .bg-yellow{background: #F7F3E7;}
</style>



// WEBPACK FOOTER //
// src/components/alertnum/alertNum.vue